import { render, staticRenderFns } from "./HerbariumShowOptions.vue?vue&type=template&id=0e63c7ac&scoped=true&"
import script from "./HerbariumShowOptions.vue?vue&type=script&lang=js&"
export * from "./HerbariumShowOptions.vue?vue&type=script&lang=js&"
import style0 from "./HerbariumShowOptions.vue?vue&type=style&index=0&id=0e63c7ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e63c7ac",
  null
  
)

export default component.exports